import { render, staticRenderFns } from "./UserGroupForm.vue?vue&type=template&id=df5d064a&scoped=true"
import script from "./UserGroupForm.vue?vue&type=script&lang=js"
export * from "./UserGroupForm.vue?vue&type=script&lang=js"
import style0 from "./UserGroupForm.vue?vue&type=style&index=0&id=df5d064a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5d064a",
  null
  
)

export default component.exports